import { setAuthenticatedUserContext, clearAuthenticatedUserContext } from '../util/analytics/ApplicationInsights'

export const TOKEN_KEY = 'authToken'

// base class for authorization used with RedBit projects. Currnelty built for JWT tokens
class RBAuthorizationBase {
  constructor () {
    // the access token that is available
    this._accessToken = ''

    // the sub part of the payload for a JWT token
    this.claims = null

    // get the access token from the local storage
    this.accessToken = window.localStorage.getItem(TOKEN_KEY)
  }

  // gets a value to determine if user is authenticated or not
  get isAuthenticated () {
    return window.localStorage.getItem(TOKEN_KEY) !== null
  }

  // get the name associated with the claims
  get name () {
    if (this.claims) { return this.claims.name } else { return null }
  }

  // gets the sub vlaim value if available
  get sub () {
    if (this.claims) { return this.claims.sub } else { return null }
  }

  // gets whether the user is allowed to submit a claim or not
  get canSubmitClaim () {
    // NOTE: we check for a string of try b/c the claim is a string and JSON might treat this as a string not a bool
    if (this.claims) { return this.claims.ngrxSubmitClaimOnline === 'True' } else { return false }
  }

  get accessToken () {
    return this._accessToken
  }

  // sets the access token and extracts the claims
  set accessToken (token) {
    if (token) {
      // parse out the token
      var claimStringItems = token.split('.')
      if (claimStringItems.length === 3) {
        // we have the right amount so get the payload and decode it
        var payload = global.atob(claimStringItems[1])
        this.claims = JSON.parse(payload)

        // save to local storage
        window.localStorage.setItem(TOKEN_KEY, token)

        // save to memory
        this._accessToken = token

        // save the auth details
        const id = this.claims.ngrxMemberCertNum
        if (!id) {
          console.warn(`ngrxMemberCertNum is null for subject ${this.sub}`)
        } else {
          setAuthenticatedUserContext(id, id)
        }
      } else {
        // something is wrong with the claims so just set to false
        this.claims = null
        this._accessToken = ''
        window.localStorage.removeItem(TOKEN_KEY)

        // clear app insights
        clearAuthenticatedUserContext()
      }
    } else {
      // the token is not available so clear everything
      this.claims = null
      this._accessToken = ''
      window.localStorage.removeItem(TOKEN_KEY)

      // clear app insights
      clearAuthenticatedUserContext()
    }
  }
}

class NgrxAuthorization extends RBAuthorizationBase {
  // gets the member id associted with the signed in user
  get memberId () {
    if (this.claims) { return this.claims.sub } else { return null }
  }

  // gets the policy number associated with the signed in user
  get policyNumber () {
    if (this.claims) { return this.claims.ngrxPolicyNumber } else { return null }
  }

  // gets the policy name associated with the signed in user
  get policyName () {
    if (this.claims) { return this.claims.ngrxPolicyName } else { return null }
  }

  // gets the session Token associated with the signed in user
  get sessionId () {
    if (this.claims) { return this.claims.ngrxSessionToken } else { return null }
  }

  // gets the current signed in members certificate number
  get certificateNumber () {
    if (this.claims) { return this.claims.ngrxMemberCertNum } else { return null }
  }

  // gets the flag whether resources are available to download
  get isAnyMemberResource () {
    if (this.claims) { return this.claims.ngrxIsAnyMemberResource === 'True' } else { return false }
  }

  // gets the members helpline number
  get memberHelpLineNumber () {
    if (this.claims) { return this.claims.ngrxHelpLineNumber } else { return null }
  }

  get ngrxMultiPolicies () {
    if (this.claims && this.claims.ngrxMultiPolicies) {
      const policies = window.atob(this.claims.ngrxMultiPolicies)
      return JSON.parse(policies)
    } else { return [] }
  }

  get ngrxIsMultiPolicies () {
    if (this.claims) { return this.claims.ngrxIsMultiPolicies } else { return false }
  }

  /**
   * Gets the hours of operation for the helpline for a given member
   *
   * @readonly
   * @memberof NgrxAuthorization
   */
  get memberHelpLineHours () {
    if (this.claims) { return this.claims.ngrxHelpLineHours } else { return null }
  }

  // get isTokenExpired () {
  //   if (this.claims) {
  //     const currentTimeStamp = moment.utc()
  //     const authExpTime = moment.utc(this.claims.exp, 'X')
  //     if ((authExpTime - currentTimeStamp) > 0) {
  //       return false
  //     } else {
  //       return true
  //     }
  //   } else { return true }
  // }
}

const NgrxAuth = new NgrxAuthorization()

export default NgrxAuth



// WEBPACK FOOTER //
// ./src/auth/Auth.js